<div class="test-banner" *ngIf="showTestBanner">TEST ENVIRONMENT - NOT FOR PRODUCTION USE</div>